/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerifyFuelPurchaseResponse
 */
export interface VerifyFuelPurchaseResponse {
    /**
     * Outcome of the verification.
     * @type {string}
     * @memberof VerifyFuelPurchaseResponse
     */
    status: VerifyFuelPurchaseResponseStatusEnum;
    /**
     * Stripe decline code or internal outcome code.
     * @type {string}
     * @memberof VerifyFuelPurchaseResponse
     */
    reason?: string;
    /**
     * User-facing message for this outcome.
     * @type {string}
     * @memberof VerifyFuelPurchaseResponse
     */
    message: string;
}


/**
 * @export
 */
export const VerifyFuelPurchaseResponseStatusEnum = {
    success: 'success',
    fail: 'fail',
    credit_failed: 'credit_failed'
} as const;
export type VerifyFuelPurchaseResponseStatusEnum = typeof VerifyFuelPurchaseResponseStatusEnum[keyof typeof VerifyFuelPurchaseResponseStatusEnum];


/**
 * Check if a given object implements the VerifyFuelPurchaseResponse interface.
 */
export function instanceOfVerifyFuelPurchaseResponse(value: object): value is VerifyFuelPurchaseResponse {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function VerifyFuelPurchaseResponseFromJSON(json: any): VerifyFuelPurchaseResponse {
    return VerifyFuelPurchaseResponseFromJSONTyped(json, false);
}

export function VerifyFuelPurchaseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyFuelPurchaseResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'message': json['message'],
    };
}

export function VerifyFuelPurchaseResponseToJSON(json: any): VerifyFuelPurchaseResponse {
    return VerifyFuelPurchaseResponseToJSONTyped(json, false);
}

export function VerifyFuelPurchaseResponseToJSONTyped(value?: VerifyFuelPurchaseResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'reason': value['reason'],
        'message': value['message'],
    };
}

